import React, { ReactElement } from "react";
import { ParticularsProps } from "../../types/Particulars";
import { Trans, useTranslation } from "react-i18next";
import "./Particulars.css";

export const Particulars = (props: ParticularsProps): ReactElement => {
    const { t } = useTranslation("common");
    const particulars = props.particulars;

    return (
        <div className="grid">
            {Object.keys(particulars)
                .filter(
                    (key) =>
                        particulars[key as keyof ParticularsProps] !==
                            undefined &&
                        particulars[key as keyof ParticularsProps]?.toString()
                            .length &&
                        t(`inspectionReport.particulars.${key}`) !==
                            `inspectionReport.particulars.${key}`
                )
                .map((key) => {
                    return (
                        <div
                            key={key}
                            className="col-12 sm:col-6 md:col-4 lg:col-3"
                        >
                            <p className="particulars-header">
                                <Trans
                                    ns="common"
                                    i18nKey={`inspectionReport.particulars.${key}`}
                                />
                            </p>
                            <p data-cy={key.toLowerCase()}>
                                {particulars[key as keyof ParticularsProps]}
                            </p>
                        </div>
                    );
                })}
        </div>
    );
};
